import React from "react";
import { useQuery } from "@apollo/client";
import { useHistory } from "react-router";
import {
  Card,
  CardBody,
  Table,
  Spinner,
  Col,
  Container,
  Row,
} from "reactstrap";
import moment from "moment";
import {
  GET_EMPLOYEE_KPI_BY_EMPLOYEE_ID,
  GET_USER_BY_USERID,
} from "@/GraphQL/Queries";
import Loader from "@/containers/Account/Profile/components/Loader";
import BreadCrumb from "@/shared/components/BreadCrumb/BreadCrumb";
import SubmitLoading from "@/utils/HelperComponent/SubmitLoading";

export default function KpiView() {
  const history = useHistory();
  const employee_id = history?.location?.state?.id;
  const LoadUserProfile = useQuery(GET_USER_BY_USERID, {
    skip: !employee_id,
    variables: {
      id: Number(employee_id),
    },
  });
  const { data, loading, error } = useQuery(GET_EMPLOYEE_KPI_BY_EMPLOYEE_ID, {
    variables: { employee_id: Number(employee_id) },
    skip: !employee_id,
  });

  const kpiData = data?.getEmployeeKpiByEmployeeId || [];

  if (loading || LoadUserProfile.loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <SubmitLoading color="black" />
      </div>
    );
  }
  if (error) return <p className="text-danger">Error: {error.message}</p>;
  const breadCrumbData = [
    {
      name: "Dashboard",
      link: "/",
    },
    {
      name: "Department",
      link: "/department/list",
    },
    {
      name: "Kpi View",
    },
  ];

  return (
    <Container>
      <Row>
        <Col>
          <BreadCrumb breadCrumbData={breadCrumbData} />
        </Col>
      </Row>
      <Row>
        <Col md={12} className="mx-auto">
          <div>
            <div className="profile__card pt-4">
              <div className="d-flex flex-column align-items-center">
                <div className="profile__avatar">
                  <img
                    className="img-fluid"
                    src={
                      LoadUserProfile?.data?.getUserByUserid?.images ||
                      "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png"
                    }
                    alt="Profile"
                    onError={(e) => {
                      e.target.onerror = null; // Prevents looping if the fallback image also fails
                      e.target.src =
                        "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_640.png";
                    }}
                  />
                </div>
                <div className="profile__data text-center mt-4">
                  <h4 className="profile__name">
                    {LoadUserProfile?.data?.getUserByUserid?.name}
                  </h4>
                  <p className="profile__work">
                    {
                      LoadUserProfile?.data?.getUserByUserid?.additionalInfo
                        ?.designationInfo?.name
                    }
                    ,{" "}
                    {
                      LoadUserProfile?.data?.getUserByUserid?.additionalInfo
                        ?.departmentInfo?.name
                    }
                  </p>
                </div>
              </div>
            </div>
            <Card>
              <CardBody>
                <h4 className="mb-4 text-center fw-bold">
                  📊 Employee KPI Overview
                </h4>

                {kpiData.length === 0 ? (
                  <p className="text-center">No KPI records found.</p>
                ) : (
                  kpiData.map((entry, index) => (
                    <div key={index} className="mb-4">
                      <h5>
                        Duration:&nbsp;
                        {moment(entry.duration?.start_date).format(
                          "MMMM YYYY"
                        )}{" "}
                        to{" "}
                        {moment(entry.duration?.end_date).format("MMMM YYYY")}
                      </h5>

                      <Table bordered responsive striped>
                        <thead className="thead-light">
                          <tr>
                            <th>#</th>
                            <th>KPI</th>
                            <th>Description</th>
                            <th>Target</th>
                          </tr>
                        </thead>
                        <tbody>
                          {entry.kpiList?.map((kpi, idx) => (
                            <tr key={kpi.id}>
                              <td>{idx + 1}</td>
                              <td>{kpi.key_area}</td>
                              <td
                                dangerouslySetInnerHTML={{
                                  __html: kpi.description,
                                }}
                              />
                              <td>{kpi.target ?? "-"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ))
                )}
              </CardBody>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
